import React, { useState } from 'react';
//API
import api from "../services/api";

//Feather
import {
  Copy
} from "react-feather";

import openToast from "../utils/sweetAlert";

//Context
import { useAuth } from '../providers/auth';
import LoadingCenter from './LoadingCenter';

export default function CopyBox(props) {
  const { user: usertoken } = useAuth();

  const user = props.user;

  const copyToClipboard = () => navigator.clipboard.writeText(user.phone)

  const [infoLoading, setInfoLoading] = useState(false);

  async function copyNumber(id) {
    const options = { headers: { "Authorization": "Bearer " + usertoken.token } };
    try {
      setInfoLoading(true);
      const response = await api.get(`/emailform/phone/${id}`, options);
      if (response.data.error) {
        openToast("error", "Erro", response.data.message)
      } else {
        openToast("success", "Copiou", "Número copiado com sucesso!")
        // copia o texto para a area de transferencia do computador
        navigator.clipboard.writeText(response.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setInfoLoading(false);
    }
  }

  return (
    infoLoading ? (
      <LoadingCenter />
    ) : (
      <tr>
        <td className="limit-chars-name">
          <span className="text-color">{user.name}</span>
        </td>
        <td className="limit-chars-message">
          <span className="text-color">{user.message}</span>
        </td>
        <td className="limit-chars-number">
          <button style={{ border: "none" }} onClick={() => copyNumber(user.id)}>
            <Copy />
          </button>
        </td>
      </tr>
    )
  );
}